import { VFC, useCallback, useEffect } from "react";
import { useClipboard } from "@chakra-ui/react";
import { CopyIcon } from '@chakra-ui/icons';
import { useMessage } from "../../../hooks/useMessage";

type Props = {
  color?: string;
  id: string;
  value: string;
};

export const CopyIconButton: VFC<Props> = (props) => {
  const {
    color = "green.400",
    id,
    value,
  } = props;
  const { showMessage } = useMessage();
  const { hasCopied, onCopy } = useClipboard(value);
  
  // コピー用バッファ設定
  const doCopy = useCallback(() => {
    onCopy();
  }, [onCopy]);
  
  // コピー実行
  useEffect(() => {
    //console.log(copyBuf);
    hasCopied && showMessage({ title: "コピーしました", status: "success" });
    // eslint-disable-next-line
  }, [hasCopied]);
  
  return (
    <CopyIcon id={id} color={color} onClick={doCopy}/>
  );
};
